import { render, staticRenderFns } from "./basepropertybill.vue?vue&type=template&id=4b6e0c52&scoped=true&"
import script from "./basepropertybill.vue?vue&type=script&lang=js&"
export * from "./basepropertybill.vue?vue&type=script&lang=js&"
import style0 from "./basepropertybill.vue?vue&type=style&index=0&id=4b6e0c52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6e0c52",
  null
  
)

export default component.exports